<template>
  <div>
    <v-dialog
      v-model="show"
      width="90%"
      max-width="90wv"
      scrollable
    >
      <v-card>
        <v-card-title>
          Logs
          <v-spacer></v-spacer>
          <div>
            <v-row>
              <v-col>
                <RangeDatePickerMenu
                  v-model="period"
                  showButtons
                  @onOkClick="showLogs"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  placeholder="Time From"
                  dense
                  hide-details
                  :items="times"
                  v-model="timeFrom"
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  placeholder="Time To"
                  dense
                  hide-details
                  :items="times"
                  v-model="timeTo"
                ></v-select>
              </v-col>
            </v-row>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-3">
           <v-data-table
              dense
              fixed-header
              height="60vh"
              :headers="tableHeaders"
              :items="logs"
              :items-per-page="-1"
              hide-default-footer
            >
            </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            outlined
            color="primary"
            small
            @click="show = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="ml-4"
            small
            @click="showLogs"
            :disabled="choosenPeriod.length === 0"
          >
            Show
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'ErrorLogs',
  components: {
    RangeDatePickerMenu: () => import('@/components/global/RangeDatePickerMenu.vue')
  },
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      period: [],
      timeFrom: '00:00',
      timeTo: '23:00',
      datesMenu: false,
      logs: [],
      tableHeaders: [
        {
          text: 'Login',
          value: 'Login',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap a-top'
        },
        {
          text: 'Request',
          value: 'Request',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap a-top'
        },
        {
          text: 'Method',
          value: 'Method',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap a-top'
        },
        {
          text: 'Time',
          value: 'Time',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap a-top'
        },
        {
          text: 'Error',
          value: 'Error',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 a-top'
        },
        {
          text: 'Parameters',
          value: 'Parameters',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 a-top'
        },
        {
          text: 'SQL Query',
          value: 'SQL_Query',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 a-top'
        },
        {
          text: 'Request Headers',
          value: 'Request_Headers',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 a-top'
        }
      ]
    }
  },
  computed: {
    times () {
      const times = []
      for (let i = 0; i < 24; i++) {
        if (i < 10) times.push('0' + i + ':00')
        else times.push(i + ':00')
      }
      return times
    },
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    choosenPeriod () {
      if (this.period.length === 1) return [this.period[0], this.period[0]]
      return this.period
    }
  },
  methods: {
    updateDates (e) {
      const d1 = +(new Date(e[0]))
      const d2 = +(new Date(e[1]) || new Date(e[0]))
      if (d1 < d2) this.period = [e[0], e[1]]
      else if (d1 > d2) this.period = [e[1], e[0]]
      else this.period = [e[0], e[1]]
      if (d1 && d2) this.datesMenu = false
    },
    showLogs () {
      const periodFrom = this.choosenPeriod[0] + ' ' + this.timeFrom
      const periodTo = this.choosenPeriod[1] + ' ' + this.timeTo
      this.axios.get(`/api/error_logs/${periodFrom}/${periodTo}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.logs = res.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.response?.data || 'Something went wrong' })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .a-top {
    vertical-align: top;
  }
</style>
